<div mat-dialog-title style="margin-bottom: 0px;">
  <div class="d-flex justify-content-between align-items-center">
    <h1 mat-dialog-title> {{ formMode
      ? (langObj?.AddTaskParamaterTarget || ('AddTaskParamaterTarget' | translate))
      : (langObj?.UpdateTaskParamaterTarget || ('UpdateTaskParamaterTarget' | translate))
      }}
    </h1>
    <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
      <i class="fa fa-times" style="color: #fff"></i>
    </button>
  </div>
</div>

<div class="d-flex align-items-center" style="margin-top:10px;">
  <button mat-mini-fab mat-button *ngIf="isAccess | permissionChecker" color="accent" (click)="addTable()"
    matTooltip="Add Row" type="button" matTooltipClass="custom-tooltip" matTooltipPosition="above"
    style="margin-left: 20px; background-color: #19ACAB; display: flex; justify-content: center; align-items: center;">
    <i class="fa fa-calendar-plus-o" style="color: #fff; vertical-align: initial;"></i>
  </button>
</div>

<div style="margin-top: 10px"></div>
<form [formGroup]="parameterRowData">
  <table mat-table [dataSource]="parameterAddModel" class="basic-table plant-model-table" matSort>
    <ng-container matColumnDef="itemActions">
      <th mat-header-cell *matHeaderCellDef>
        <p class="header-text">{{langObj ? langObj?.Action : ('Action' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element; let i = index" style="width: 100px;">
        <div class="row-action-btns">
          <button mat-icon-button type="button" *ngIf="isDelete | permissionChecker" class="tree-view-btn"
            (click)="deleteRow(element, i)" matTooltip="Delete" matTooltipClass="custom-tooltip"
            matTooltipPosition="above">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V24C34 29.5228 29.5228 34 24 34H10C4.47715 34 0 29.5228 0 24V10Z"
                fill="#F85439" />
              <circle cx="17" cy="17" r="14" fill="#F85439" />
              <path
                d="M20.9157 12.2611H18.874L18.2907 11.6777H15.374L14.7907 12.2611H12.749V13.4277H20.9157V12.2611ZM13.3324 21.0111C13.3324 21.3205 13.4553 21.6172 13.6741 21.836C13.8929 22.0548 14.1896 22.1777 14.499 22.1777H19.1657C19.4751 22.1777 19.7719 22.0548 19.9906 21.836C20.2094 21.6172 20.3324 21.3205 20.3324 21.0111V14.0111H13.3324V21.0111Z"
                fill="white" />
            </svg>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="parameter">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%;padding-left: 0px">
        <p class="header-text">{{langObj ? langObj?.Parameter : ('Parameter' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element;let i = index"
        style="padding: 13px 0px; padding-right: 10px; padding-left: 10px;">
        <mat-select name="parameter" (selectionChange)="columnItemEvent($event, element,i)"
          placeholder="Choose Parameter" [value]="element.parameter">
          <mat-select-filter [placeholder]="'Search Parameter'" [displayMember]="'Var_Desc'" [array]="parameters"
            (filteredReturn)="filteredParameters = $event"></mat-select-filter>
          <mat-option *ngFor="let p of filteredParameters" [value]="p.Var_Id">{{ p.Var_Desc }}</mat-option>
        </mat-select>
      </td>
    </ng-container>

    <ng-container matColumnDef="actual">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;">
        <p class="header-text">{{langObj ? langObj?.Actual : ('Actual' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <input matInput type="number" (change)="updateValue($event, element, 'actual', i)" placeholder="Add Actual"
          [value]="element.actual" min="0" />
      </td>
    </ng-container>

    <ng-container matColumnDef="lifeSpan">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;">
        <p class="header-text">{{langObj ? langObj?.LifeSpan : ('LifeSpan' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <input matInput type="number" (change)="updateValue($event, element, 'lifeSpan', i)" placeholder="Add Life Span"
          [value]="element.lifeSpan" min="0" />
      </td>
    </ng-container>

    <ng-container matColumnDef="target">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;">
        <p class="header-text">{{langObj ? langObj?.Target : ('Target' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <input matInput type="number" (change)="updateValue($event, element, 'target', i)" placeholder="Add Target"
          [value]="element.target" min="0" />
      </td>
    </ng-container>

    <ng-container matColumnDef="rules">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 30%;">
        <p class="header-text">{{langObj ? langObj?.Rules : ('Rules' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="d-flex">
          <mat-form-field appearance="float" style="width: 33%;">
            <mat-label>{{langObj ? langObj?.Number : ('Number' | translate)}}</mat-label>
            <input matInput type="number" (change)="updateRule($event, element, 'number', i)"
              [value]="element.rules?.number" min="0" />
          </mat-form-field>

          <mat-form-field appearance="float" style="width: 33%;">
            <mat-label>{{langObj ? langObj?.Condition : ('Condition' | translate)}}</mat-label>
            <mat-select (selectionChange)="updateRule($event, element, 'condition', i)"
              [value]="element.rules?.condition">
              <mat-option value=""></mat-option>
              <mat-option value=">">&gt;</mat-option>
              <mat-option value="<">&lt;</mat-option>
              <mat-option value=">=">&gt;=</mat-option>
              <mat-option value="<=">&lt;=</mat-option>
              <mat-option value="=">=</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="float" style="width: 33%;">
            <mat-label>{{langObj ? langObj?.Unit : ('Unit' | translate)}}</mat-label>
            <mat-select (selectionChange)="updateRule($event, element, 'unit', i)" [value]="element.rules?.unit">
              <mat-option value=""></mat-option>
              <mat-option value="%">%</mat-option>
              <mat-option value="value">Value</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="itemColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: itemColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" style="text-align: center" colspan="6">
        {{langObj ? langObj?.nodatamatch : ('nodatamatch' | translate)}}
      </td>
    </tr>
  </table>
  <mat-paginator class="basic-paginataor" [pageSizeOptions]="[5, 10]" showFirstLastButtons></mat-paginator>
  <div mat-dialog-actions style="float: right; margin-top: 10px">
    <button (click)="createParameterTarget()" mat-mini-fab mat-button color="primary"
      *ngIf="formMode && isWrite | permissionChecker" matTooltip="Save" matTooltipClass="custom-tooltip"
      matTooltipPosition="above" style="margin-left: 20px;">
      <i class="fa fa-floppy-o" style="color: #fff"></i>
    </button>
    <button mat-mini-fab mat-button color="primary" [disabled]="isLoading || addtabledata.length === 0"
      *ngIf="!formMode && isUpdate | permissionChecker" matTooltip="Update" matTooltipClass="custom-tooltip"
      matTooltipPosition="above" style="margin-left: 20px;" (click)="updateCheckList()">
      <mat-icon *ngIf="!isLoading">edit</mat-icon>
      <mat-spinner color="accent" *ngIf="isLoading" diameter="20"></mat-spinner>
    </button>
  </div>
</form>